import { Box, HStack, Header, Icon, addWithConfig } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { IncentiveEvaluationMessages } from 'components/incentive-evaluation-messages/incentive-evaluation-messages';
import { DisclaimerContainer } from 'components/offer-disclaimer/offer-disclaimer';
import Picture from 'components/picture';
import { ProgressMeter } from 'components/progress-meter';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { ZIndex, getDesignToken, primitive, spacing } from 'styles/constants';

import { RewardPointCost } from '../reward-point-cost';

export const ImageWrapper = Box.withConfig({
  alignItems: 'center',
  paddingTop: spacing.$2,
});

export const StyledRewardImage = Picture.withConfig({
  width: '100%',
  zIndex: ZIndex.NORMAL,
});

export const BackgroundImage = Picture.withConfig({
  position: 'absolute',
  left: 0,
  top: 0,
  width: 'full',
  height: '100%',
});

export const RewardName = Header.withConfig({
  textAlign: 'center',
  fontSize: '2xl',
  lineHeight: 'md',
  marginTop: '$4',
  maxWidth: '960px',
  mb: '$1',
});

export const RewardDescription = SanityBlockRenderer.withConfig({
  color: primitive.$greyOne,
  _text: {
    textAlign: 'center',
    fontSize: 'sm',
  },
  textProps: { fontSize: 'md', textAlign: 'center' },
});

export const RewardExpiration = Box.withConfig({
  color: primitive.$greyOne,
  marginTop: '$3',
});

export const ButtonContainer = Box.withConfig({
  flexShrink: 0,
  width: 'full',
  maxWidth: '100%',
});

export const RewardDetailsContainer = Box.withConfig({
  alignItems: 'center',
  paddingX: '$0',
  marginBottom: '$4',
  gap: '$2',
});

export const DisclaimerText = SanityBlockRenderer.withConfig({
  maxWidth: '512px',
  marginY: '$8',
  marginX: 'auto',
  textProps: {
    color: primitive.$greyOne,
    textAlign: 'center',
    fontSize: 'xs',
  },
});

export const StyledProgressMeter = ProgressMeter.withConfig({
  borderWidth: 0,
  marginY: '$4',
  width: '240px',
  bgColor: primitive.$white,
});

export const PointsContainer = Box.withConfig({
  alignItems: 'center',
  marginTop: '$6',
});

export const PointsTextContainer = HStack.withConfig({
  alignItems: 'center',
});

export const StyledRewardPointCost = RewardPointCost.withConfig({
  fontSize: '2xl',
  lineHeight: 'md',
  fontWeight: 'bold',
  alignItems: 'center',
});

export const StyledPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '32px',
  height: '32px',
  marginRight: '8px',
  fill: '#FFAA00',
});

export const StyledRewardLockIcon = Icon.withConfig({
  variant: 'locked',
  size: 7,
  color: getDesignToken('icon-default'),
});

export const StyledIncentiveEvaluationMessages = IncentiveEvaluationMessages.withConfig({
  textAlign: 'center',
});

export const AddToCartButton = addWithConfig(ActionButton).withConfig<{ isOffer?: boolean }>(
  props => ({
    fontSize: 'lg',
    justifyContent: 'center',
    paddingX: '$12',
    minHeight: '48px',
    width: 'full',
    textDecorationColor: primitive.$bbqBrown,

    ...(!props.isOffer && {
      backgroundColor: primitive.$meltyYellow,
      _text: { color: primitive.$bbqBrown },
      _hover: { backgroundColor: primitive.$meltyYellowDark45 },
      _pressed: { backgroundColor: primitive.$meltyYellowDark40 },
      color: primitive.$bbqBrown,
    }),
  })
);

export const RedeemInRestaurantButton = addWithConfig(ActionButton).withConfig<{
  isOffer?: boolean;
}>(props => ({
  fontSize: 'lg',
  justifyContent: 'center',
  paddingX: '$12',
  minHeight: '48px',
  width: 'full',
  textDecorationColor: primitive.$bbqBrown,

  ...(!props.isOffer && {
    borderColor: primitive.$bbqBrown,
    _text: { color: primitive.$bbqBrown },
    _hover: {
      backgroundColor: primitive.$bbqBrownOpacity15,
      borderColor: primitive.$bbqBrown,
    },
    _pressed: {
      backgroundColor: primitive.$bbqBrownOpacity15,
      borderColor: primitive.$bbqBrown,
    },
  }),
}));

export const RemoveFromCartButton = addWithConfig(ActionButton).withConfig({
  fontSize: 'lg',
  justifyContent: 'center',
  paddingX: '$12',
  height: '48px',
  variant: ActionButtonVariants.OUTLINE,
});

export const ButtonsWrapper = Box.withConfig<{ $errorMessage?: boolean }>(props => ({
  marginTop: props.$errorMessage ? '0' : '$4',
  marginY: '$4',
  alignItems: 'center',
  zIndex: ZIndex.TOP,
  paddingTop: {
    base: '$4',
    md: '$8',
  },
  paddingX: '$4',
  paddingBottom: '$4',
  ...props,
}));

export const StyledDisclaimerContainer = DisclaimerContainer.withConfig({
  marginTop: '$4',
});
